import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Faq extends Model {
  resource() {
    return 'faqs'
  }

  get status() {
    return this.active ? 'Enabled' : 'Disabled'
  }

  get statusColor() {
    return this.active ? 'primary' : 'red'
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }
}
